// A short confirmation after a browser is marked (or unmarked) as Kibu staff from the ERP. Customers never see it.
import { useEffect, useState } from 'react'
import { getManualInternalTrafficChange, type InternalTrafficChange } from '../utils/internalTraffic'

const InternalTrafficNotice = () => {
    const [change, setChange] = useState<InternalTrafficChange | null>(() => getManualInternalTrafficChange())

    useEffect(() => {
        if (!change) return undefined
        const timer = window.setTimeout(() => setChange(null), 8000)
        return () => window.clearTimeout(timer)
    }, [change])

    if (!change) return null
    return (
        <div role="status" className="fixed inset-x-4 bottom-4 z-[9999] mx-auto flex max-w-md items-start gap-3 rounded-xl bg-black px-4 py-3 text-sm text-white shadow-lg">
            <p className="flex-1 leading-5">
                {change === 'marked'
                    ? 'This browser is marked as Kibu staff. Your visits and orders here won’t count in marketing reports.'
                    : 'This browser is no longer marked as Kibu staff.'}
            </p>
            <button type="button" className="shrink-0 underline underline-offset-2" onClick={() => setChange(null)}>
                Close
            </button>
        </div>
    )
}

export default InternalTrafficNotice
